import { render, staticRenderFns } from "./MResetPassEmail.vue?vue&type=template&id=2b0e7fbd&scoped=true&"
import script from "./MResetPassEmail.vue?vue&type=script&lang=ts&"
export * from "./MResetPassEmail.vue?vue&type=script&lang=ts&"
import style0 from "./MResetPassEmail.vue?vue&type=style&index=0&id=2b0e7fbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0e7fbd",
  null
  
)

export default component.exports